import moment from "moment";

export function buildDownloadFileName(
  record_name?: string | null,
  created_date?: string | null,
  options?: { extension?: string; suffix?: string },
) {
  const extension = options?.extension ?? "docx";
  const suffix = options?.suffix;
  const cleanName = (record_name || "toplanti")
    .trim()
    .replace(/[<>:"/\\|?*]/g, "")
    .replace(/\s+/g, "_")
    .slice(0, 80);
  const safeName = cleanName || "toplanti";
  const date =
    created_date && moment(created_date).isValid() ? moment(created_date) : moment();
  const suffixPart = suffix ? `_${suffix}` : "";
  return `${safeName}${suffixPart}_${date.format("YYYY-MM-DD_HH-mm")}.${extension}`;
}
